import { configureStore } from "@reduxjs/toolkit";
import { loginApi } from "./action/login";
import { orders, login, adminFees, importExportProducts, inquiry } from "./reducer";
import { orderApi } from "./action/admin-orders";
import { adminFeeApi } from "./action/admin-fee"
import { importExportProductsApi } from "./action/import-export-products";
import { optionsStoreApi } from "./action/options-store";
import { inquiryApi } from "./action/inquiryApi";
import { siteConfigApi } from "./action/site-config";
import { invoiceApi } from "./action/invoiceApi";
import { authMiddleware } from "./authMiddleware";
import { sentryErrorMiddleware } from "./sentryMiddleware";
import { userRoleApi } from "./action/userRoleApi";
import { salesUserApi } from "./action/salesUserApi";
import { salesLeadsApi } from "./action/salesLeadsApi";
import { staffUserApi } from "./action/staffUserApi";

export const store = configureStore({
  reducer: {
    [orderApi.reducerPath]: orderApi.reducer,
    [adminFeeApi.reducerPath]: adminFeeApi.reducer,
    [importExportProductsApi.reducerPath]: importExportProductsApi.reducer,
    [loginApi.reducerPath]: loginApi.reducer,
    [optionsStoreApi.reducerPath]: optionsStoreApi.reducer,
    [inquiryApi.reducerPath]: inquiryApi.reducer,
    [siteConfigApi.reducerPath]: siteConfigApi.reducer,
    [invoiceApi.reducerPath]: invoiceApi.reducer,
    [userRoleApi.reducerPath]: userRoleApi.reducer,
    [salesUserApi.reducerPath]: salesUserApi.reducer,
    [salesLeadsApi.reducerPath]: salesLeadsApi.reducer,
    [staffUserApi.reducerPath]: staffUserApi.reducer,
    inquiry: inquiry,
    orders: orders,
    adminFees: adminFees,
    importExportProducts: importExportProducts,
    login: login,
  },


  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware()
      .concat(orderApi.middleware)
      .concat(loginApi.middleware)
      .concat(adminFeeApi.middleware)
      .concat(importExportProductsApi.middleware)
      .concat(optionsStoreApi.middleware)
      .concat(inquiryApi.middleware)
      .concat(siteConfigApi.middleware)
      .concat(invoiceApi.middleware)
      .concat(userRoleApi.middleware)
      .concat(salesUserApi.middleware)
      .concat(salesLeadsApi.middleware)
      .concat(staffUserApi.middleware)
      .concat(authMiddleware)
      .concat(sentryErrorMiddleware)
  }
});